export default __webpack_public_path__ + "static/media/u.ad002db0.svg";